import s from '@/pages/ConnectorInfo/ConnectorInfo.module.scss';
import { Flex } from '@tremor/react';
import { FormEvent } from 'react';
import { useConnectorAuth } from '@/hooks/useConnectorAuth';
import { ConnectorTitle } from '../ConnectorTitle/ConnectorTitle';
import { ConnectionSteps } from '@/components/ConnectionSteps/ConnectionSteps';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';
import { ConnectorSubtitle } from '../ConnectorSubtitle/ConnectorSubtitle';
import { ConnectorRadioButton } from '../../Inputs/ConnectorRadioButton/ConnectorRadioButton';
import { BottomActions } from '../BottomActions/BottomActions';

const defaultValChecked = 'login-with-google';

const scope =
  'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
const uriScope = encodeURIComponent(scope);
export const GoogleAdsInfoConnector = () => {
  const [setSelectedMethod, , isLoading, generateOAuthLink] = useConnectorAuth(
    defaultValChecked,
    {
      platform: 'google-ads',
      OAuthUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
      clientID: import.meta.env._VITE_GOOGLE_APP_ID,
    },
    'prompt=consent&response_type=code&access_type=offline',
  );

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    window.location.href = await generateOAuthLink(uriScope);
  };

  return (
    <form className={s.form} onSubmit={handleSubmit}>
      <ConnectorTitle connectorId="google-ads">Google Ads</ConnectorTitle>
      <ConnectionSteps
        style={{ marginBottom: '40px' }}
        steps={FACEBOOK_CONNECTION_STEPS}
        currentStep={1}
      />
      <ConnectorSubtitle>Connect with Google</ConnectorSubtitle>
      <Flex
        flexDirection="col"
        style={{ gap: '20px' }}
        onChange={(e) => setSelectedMethod((e.target as HTMLInputElement).value)}
      >
        <ConnectorRadioButton
          value="connect-with-google"
          name="connector"
          label="Connect With Google"
          defaultChecked
          description="Connect your historical performance data to fuel your reports"
        />

        <BottomActions isCreating={true} isLoading={isLoading} />
      </Flex>
    </form>
  );
};
